var map = {
	"./github.png": 4,
	"./github_engraved.png": 8,
	"./go.png": 9,
	"./info": 1,
	"./info.json": 1,
	"./linkedin.png": 2,
	"./pi-thumb.png": 27,
	"./post_modal.png": 28,
	"./resume.pdf": 7,
	"./resume.png": 5,
	"./rinat.jpg": 3,
	"./ringedin.png": 29,
	"./shades.png": 6,
	"./win-game.png": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;